<template>
  <article id="artist" class="layout-section -align-side-reverse -bg-shade">
    <div class="layout-section__content">
      <h2 v-scroll:reveal="{delay:75}" class="layout-section__heading">{{ content.title }}</h2>
      <div v-scroll:reveal="{delay:125}" v-html="content.text" />
    </div>

    <figure v-scroll:reveal class="layout-section__figure -reverse" :style="{ backgroundImage: `url('${content.image}')` }" />
  </article>
</template>

<script>
export default {
  name: 'HomeContent',
  computed: {
    content() {
      return this.$i18n.t('about')
    }
  }
}
</script>
